import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(auth)/password-recovery/page.tsx")